import ReactDOM from "react-dom";
import App from "./App";
import "./index.css"
import "@sweco/sweco-digital-platforms/dist/css/sweco-bootstrap.css";

ReactDOM.render(<App />, document.getElementById("root"));